import Heading from '@totallymoney/ui/components/Heading'
import Text from '@totallymoney/ui/components/Text'
// @ts-ignore
import Edit from '@totallymoney/ui/icons/Edit'
import Minus from '@totallymoney/ui/icons/Minus'
import theme from '@totallymoney/ui/theme'
import * as React from 'react'

import * as Styled from './LoansTableFilterAccordion.styled'

interface LoansTableFilterAccordionProps {
    children: React.ReactNode
    isOpen: boolean
    onFilterPress: () => void,
    subtitle: string
    title: string
}

const LoansTableFilterAccordion = ({
    isOpen,
    title,
    subtitle,
    children,
    onFilterPress,
}: LoansTableFilterAccordionProps) => {
    const contentContainer = React.useRef<HTMLDivElement | null>(null)
    const [hasFocus, setHasFocus] = React.useState(false)

    React.useLayoutEffect(() => {
        if (contentContainer.current == null) {
            return
        }
        contentContainer.current.style.visibility = isOpen
            ? 'visible'
            : 'hidden'
    }, [isOpen])

    return (
        <Styled.CollapsibleWrapper
            hasFocus={hasFocus}
            data-testid={`filter-accordion-${isOpen ? 'open' : 'closed'}`}
        >
            <Styled.HeadLineWrapperButton
                onClick={onFilterPress}
                onFocus={() => setHasFocus(true)}
                onBlur={() => setHasFocus(false)}
            >
                <Styled.HeadlineTextWrapper>
                    <Heading variant="40">{title}</Heading>
                    <Styled.SubtitleWrapper isOpen={isOpen}>
                        <Text
                            variant="80"
                            style={{
                                lineHeight: 'normal',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {subtitle}
                        </Text>
                    </Styled.SubtitleWrapper>
                </Styled.HeadlineTextWrapper>
                {isOpen ? (
                    <Minus size={18} color={theme.grey120} />
                ) : (
                    <Edit color={theme.grey120} />
                )}
            </Styled.HeadLineWrapperButton>
            <Styled.ContentContainer
                ref={ref => (contentContainer.current = ref)}
                isOpen={isOpen}
                tabIndex={isOpen ? 1 : -1}
                aria-hidden={!isOpen}
            >
                <Styled.ContentWrapper isOpen={isOpen}>
                    {children}
                </Styled.ContentWrapper>
            </Styled.ContentContainer>
        </Styled.CollapsibleWrapper>
    )
}

export default LoansTableFilterAccordion
